import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import { getIconPark } from "../../../components/propertyControls/IconSelectControl";
import _ from "lodash";

const ButtonGroupWrapper = styled.div<{
  buttonColor: string;
  textColor: string;
  fontSize: number;
  itemSpacing: number;
  fontStyle: string;
  buttonColorFocus: string;
  textColorFocus: string;
  borderRadius: string;
  iconAlign: string;
  placement: string;
}>`
  display: flex;
  height: 100%;
  gap: ${props => props.itemSpacing}px;
  .button-group-item{
    flex: 1;
    display: flex;
    flex-direction: ${props => (props.iconAlign)};
    align-items: center;
    justify-content: ${props => (props.placement)};
    color: ${props => props.textColor};
    font-size: ${props => props.fontSize};
    border-radius: ${props => props.borderRadius};
    font-style: ${props => (props.fontStyle&&props.fontStyle.indexOf('ITALIC')>=0?'italic':'normal')};
    font-weight: ${props => (props.fontStyle&&props.fontStyle.indexOf('BOLD')>=0?'bold':'normal')};
    margin-left: ${props => (props.itemSpacing==0?'-1px':'0px')};
  }
  .button-group-PRIMARY{
    background-color: ${props => props.buttonColor};
    border: 1px solid ${props => props.buttonColor};
  }
  .button-group-SECONDARY{
    border: 1px solid ${props => props.buttonColor};
  }
  .button-group-TERTIARY{}
  .button-group-active{
    color: ${props => props.textColorFocus};
    background-color: ${props => props.buttonColorFocus};
    border-color: ${props => props.buttonColorFocus};
  }
`;
function ButtonGroupIndex(props:any){
  const {
    data,
    buttonVariant,
    buttonColor,
    textColor,
    fontSize,
    fontStyle,
    buttonColorFocus,
    textColorFocus,
    itemSpacing,
    borderRadius,
    onItemClick,
    iconAlign,
    placement
  } = props;
  const [currentIndex, setCurrentIndex] = useState(0);
  const setCurrentIndexFun = (idx: number) => {
    setCurrentIndex(idx);
  };
  useEffect(()=>{
    let defaultIndex = _.findIndex(_.values(data), {isFocus:true});
    setCurrentIndex(defaultIndex||0);
  }, [data])
  return (
    <ButtonGroupWrapper
      buttonColor={buttonColor}
      textColor={textColor}
      fontSize={fontSize}
      fontStyle={fontStyle}
      buttonColorFocus={buttonColorFocus}
      textColorFocus={textColorFocus}
      borderRadius={borderRadius}
      itemSpacing={itemSpacing}
      iconAlign={iconAlign}
      placement={placement}
    >
      {
        Object.values(data).map((i:any, idx:number)=>{
          return (
            <div key={i.id} onClick={()=>{
              setCurrentIndexFun(idx);
              i.onClick&&onItemClick(i.onClick);
            }} className={`button-group-item button-group-${buttonVariant} ${currentIndex===idx?'button-group-active':''}`}>
              {i.iconName && getIconPark(i.iconName)}
              <div className={`button-group-item-text`}>{i.label}</div>
            </div>
          )
        })
      }
    </ButtonGroupWrapper>
  )
}

export default ButtonGroupIndex;
